import { render, staticRenderFns } from "./StageCorrectOptions.vue?vue&type=template&id=8c2f4ec0&"
import script from "./StageCorrectOptions.vue?vue&type=script&lang=js&"
export * from "./StageCorrectOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports